

import React, { useState } from 'react';
import Footer from '../components/Footer';
import MainForm from './MainForm';
import HeaderInvite from '../components/HeaderInvite';
import logo from '../assets/images/logos/logoBandera.svg'
import CenteredColumnLayout from '../components/CenteredColumnLayout';

const BaseLayout = () => {

  return (
    <div className='container-fluid d-flex flex-column justify-content-between m-0 p-0' 
    style={{
        minHeight: '100vh',
        backgroundImage: "url('/static/images/background.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // padding: 20,
      }}>

        <div className='header'>
            <HeaderInvite/>
        </div>

        <CenteredColumnLayout>
            <img src={logo} style={{maxHeight: "327px", maxWidth: "210px", backgroundColor: '#f5fdff64', borderRadius: '12px'}}/>
        </CenteredColumnLayout>

        <CenteredColumnLayout>
            <MainForm />
        </CenteredColumnLayout>

        

        <div className='footer'>
            <Footer />
        </div>

    </div>
  );
};

export default BaseLayout;
